import FooterDark, { DEFAULT_FOOTER_DARK } from '../../footer-variants/FooterDark';
import FooterLight                         from '../../footer-variants/FooterLight';

const VARIANTS = { dark: FooterDark, light: FooterLight };

export default function Footer() {
  const td = window.themeData ?? {};
  const ts = td.themeSettings  ?? {};
  const fs = td.footerSettings ?? {};

  const activeVariant = ts.activeFooter ?? fs.variant ?? 'dark';
  const Component     = VARIANTS[activeVariant] ?? FooterDark;
  const settings      = Object.keys(fs).length ? fs : DEFAULT_FOOTER_DARK;

  return <Component settings={settings} />;
}
